module.exports = __webpack_public_path__ + "img/video-pic4.3b03da9a.jpg";